/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceInventoryAccount extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceInventoryAccount");
    }

    getFixupPrototypeFunction() { return ResourceInventoryAccount.fixupPrototype; }

    static newInstance(model: Partial<ResourceInventoryAccount>): ResourceInventoryAccount {
        let obj = Object.assign(new ResourceInventoryAccount(), model);
        ResourceInventoryAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceInventoryAccount>): ResourceInventoryAccount {
        if (!model) return null;
        return ResourceInventoryAccount.newInstance(<ResourceInventoryAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceInventoryAccount) {
        if (!obj) return;

        models.ResourceInventoryAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceInventoryAccount): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceInventoryAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Cloud accounts owning the resources. Always narrows: the accounts the caller can reach are applied to every query regardless, so naming one here can only take away from that set, never add to it.
     */
    service_account_ids: Array<string>;

}
